import {SELECT_NULL_CHECK} from "../components/steps/bi/constants/MAGIC_NUMBERS";

const initialState = {
    firstRun: true,
    currentStep: 1,
    stepData: {
        step1: {
            status: undefined
        },
        step2: {
            campus: SELECT_NULL_CHECK,
            housing: SELECT_NULL_CHECK,
            residency: SELECT_NULL_CHECK
        },
        step3: {
            studentAge: null,
            studentMaritalStatus: '',
            studentHasDependents: '',
            parentMaritalStatus: '',
            familySize: "",
            parentIncomeEarnedBy: '',
            parentAdjustedGrossIncome: "",
            parentOtherIncome: "",
            parentTaxesPaid: "",
            parentAssets: "",
            studentIncomeEarnedBy: '',
            studentAdjustedGrossIncome: "",
            studentOtherIncome: "",
            studentTaxesPaid: "",
            studentAssets: ""
        },
        step4: {
            estimatedStudentAidIndex: 0,
            ucTuition: 0,
            campusFees: 0,
            healthInsurance: 0,
            housingAndMeals: 0,
            booksAndSupplies: 0,
            personalAndTransportation: 0,
            grants: 0,
            scholarships: 0,
            cost: 0,
            expanded: true,
            panelList: {
                panelList1: {isVisible: true},
                panelList2: {isVisible: true}
            },
            backup2: {
                campus: SELECT_NULL_CHECK,
                housing: SELECT_NULL_CHECK,
                residency: SELECT_NULL_CHECK
            }
        }
    },
    errors: {
        step1: {},
        step2: {},
        step3: {},
    }
};

export const setFirstRun = () => ({
  type: 'setFirstRun'
});

export const clearAllData = () => ({
  type: 'clearAllData'
});

export const setCurrentStep = (step) => ({
    type: 'setCurrentStep',
    payload: step
});

export const setFormData = (step, data) => ({
   type: 'setFormData',
   payload: {step, data}
});

export const setError = (step, data) => ({
    type: 'setError',
    payload:{step, data}
});

export const clearErrors = (step) => ({
    type: 'clearErrors',
    payload: step
});

export const resetStep2Status = () => ({
    type: 'resetStep2Status'
});

export const cleanStep3 = () => ({
    type: 'cleanStep3'
});

export const toggle4Panel = (id) => ({
    type: 'toggle4Panel',
    payload: id
});

export const setStep4Housing = (id) => ({
    type: 'setStep4Housing',
    payload: id
});

const getStepDataCopy = (state) => ({
  step1: { ...state.stepData.step1 },
  step2: { ...state.stepData.step2 },
  step3: { ...state.stepData.step3 },
  step4: { ...state.stepData.step4 }
});

export default function appReducer(state = initialState, action) {
    const {type, payload} = action;

    let index, tempData;
    switch (type) {
        case 'setFirstRun':
          return {
            ...state,
            firstRun: false
          };
        case 'clearAllData':
          return {
            ...initialState,
            firstRun: false
          };

        case 'setCurrentStep':
            return {
                ...state,
                currentStep: payload,
            }

        case 'setFormData':
            tempData = getStepDataCopy(state);

            index = `step${payload.step}`;
            for(const [key, value] of Object.entries(payload.data)) {
                tempData[index][key] = value;
            }

            return {
                ...state,
                stepData: tempData,
            }

        case 'setError':
            tempData = {
              step1: { ...state.errors.step1 },
              step2: { ...state.errors.step2 },
              step3: { ...state.errors.step3 },
                ...state.errors,
            }

            index = `step${payload.step}`;
            tempData[index] = {};
            for(const [key, value] of Object.entries(payload.data)) {
                tempData[index][key] = value;
            }
            return {
                ...state,
                errors: tempData,
            }
        case 'clearErrors':
            tempData = {
                ...state.errors,
            }

            index = `step${payload}`;
            tempData[index] = {};

            return {
                ...state,
                errors: tempData,
            }
        case 'resetStep2Status':
            tempData = getStepDataCopy(state);

            for(const [key, value] of Object.entries(tempData.step2)) {
                if(value === 0) {
                    tempData.step2[key] = -1;
                }
            }

            let errData = {...state.errors};
            errData.step2 = {};

            return {
                ...state,
                stepData: tempData,
                errors: errData
            }
        case 'cleanStep3':
            tempData = getStepDataCopy(state);

            for(const [key,value] of Object.entries(tempData.step3)) {
                if(!isNaN(value)) {
                    tempData.step3[key] = parseInt(value);
                } else {
                    tempData.step3[key] = 0;
                }
            }

            return {
                ...state,
                stepData: tempData
            }
        case 'toggle4Panel':
            const data = getStepDataCopy(state);
            data.step4.panelList[payload].isVisible = !data.step4.panelList[payload].isVisible;

            return {
                ...state,
                stepData: data
                }
        case 'setStep4Housing':
            tempData = getStepDataCopy(state);
            tempData.step4.backup2 = payload;

            return {
                ...state,
                stepData: tempData
            }
        default:
            return state;
    }
}
